import { gql } from '@apollo/client'

export const GET_USER_COMPLETION = gql`
  query GetUserCompletion($id: ID!) {
    user(id: $id) {
      completion
    }
  }
`

export const GET_AGENDA_ITEMS_WITH_DETAIL = gql`
  query GetAgendaItemsWithDetail {
    agendaItems(first: 50) {
      edges {
        node {
          databaseId
          id
          order
          postId
          title
          lock
          detail {
            modules {
              title
              overview
              materials {
                name
                url
              }
            }
            knowledgeCheck {
              lock
              questions {
                statement
                choices {
                  correct
                  text
                }
                feedback {
                  correct
                  incorrect
                }
                point
                gradingMethod
              }
            }
          }
        }
      }
    }
  }
`
